
import { Options, Vue } from "vue-class-component";
import Breadcrumbs from "@/components/ui/BaseBreadcrumbs/index.vue";
@Options({
  name: "HomeComponentHeader",
  components: { Breadcrumbs },
})
export default class HomeComponentHeader extends Vue {}
